import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import MenuItemInformation from '../common/menuitem/MenuItemInformation';
import MenuItemChoiceSelection from '../common/menuitem/MenuItemChoiceSelection';
import MenuItemSubmitButton from '../common/menuitem/MenuItemSubmitButton';
import MenuItemAdded from '../common/menuitem/MenuItemAdded';
import { ModalCloseButton } from '../common/ModalCloseButton';

import { closeSpecial } from '../../actions/modals';
import generateSpecialPrice from '../../utils/generateSpecialPrice';

import getSpecialItemDetails from '../../selectors/specialItemDetails';

import { setCartPanel, setSpecialPanel } from '../../actions/panels';

import ViewItemChoices from './common/ViewItemChoices';
import ViewFoodItem from './common/ViewFoodItem';
import ViewPizza from './common/ViewPizza';
import ViewPizzaToppings from './common/ViewPizzaToppings';
import ViewPizzaCrusts from './common/ViewPizzaCrusts';
import ViewPizzaSauces from './common/ViewPizzaSauces';
import ViewCustomPizza from './common/ViewCustomPizza';
import ViewCustomPizzaToppings from './common/ViewCustomPizzaToppings';
import ViewCustomPizzaCrusts from './common/ViewCustomPizzaCrusts';
import ViewCustomPizzaSauces from './common/ViewCustomPizzaSauces';

class ViewSpecialModal extends React.Component {

    constructor(props) {
        super(props);

        this.showCompleted = this.showCompleted.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCart = this.handleCart.bind(this);
        this.selectSpecialItem = this.selectSpecialItem.bind(this);

        this.state = {
            specialItem: {},
            curIndex: 0
        };
    }

    showCompleted() {
        this.props.dispatch(setSpecialPanel('completed'));
    }

    handleClose() {
        this.props.dispatch(closeSpecial());
    }

    handleCart() {
        this.props.dispatch(setCartPanel(""));
        this.props.history.push('/'+this.props.sitename+'/'+this.props.locationId+'/cart');
        this.props.dispatch(closeSpecial());
    }

    selectSpecialItem() {

    }

    renderSpecialItems() {
        return (
            <div>
                <div className="selectionTitleText">
                    <p>Your Special Includes:</p>
                </div>

                {this.props.cartItem.items.map((theSpecialItem, index) => {
                    return (
                        <MenuItemChoiceSelection
                            key={index}
                            onChoicePress={() => { 
                                if (this.props.special.items[index].has_choices == 1) {
                                    this.setState(() => ({ curIndex: index }));
                                    this.props.dispatch(setSpecialPanel('choices'));
                                }
                                else {
                                    if (theSpecialItem.custom_pizza_id) {

                                        let thePizza = {};
                                        this.props.special.items[index].choices.forEach((theChoice) => {

                                            if (theChoice.id == this.props.cartItem.items[index].choice_id) {
                                                thePizza = theChoice;
                                            }
                                        });

                                        this.setState(() => ({
                                            specialItem: thePizza,
                                            curIndex: index
                                        }));
                                        
                                        this.props.dispatch(setSpecialPanel('custom_pizza'));
                                    }
                                    else if (theSpecialItem.pizza_id) {
                                        
                                        let thePizza = {};
                                        this.props.special.items[index].choices.forEach((theChoice) => {

                                            if (theChoice.id == this.props.cartItem.items[index].choice_id) {
                                                thePizza = theChoice;
                                            }
                                        });

                                        this.setState(() => ({
                                            specialItem: thePizza,
                                            curIndex: index
                                        }));
                                        
                                        this.props.dispatch(setSpecialPanel('pizza'));
                                    }
                                    else if (theSpecialItem.food_item_id) {

                                        let theFoodItem = {};
                                        this.props.special.items[index].choices.forEach((theChoice) => {

                                            if (theChoice.id == this.props.cartItem.items[index].choice_id) {
                                                theFoodItem = theChoice;
                                            }
                                        });

                                        this.setState(() => ({
                                            specialItem: theFoodItem,
                                            curIndex: index
                                        }));

                                        this.props.dispatch(setSpecialPanel('food_item'));
                                    }
                                }
                            }}
                            item={theSpecialItem}
                            selection={this.props.cartItem.choices.find((theSelection) => {
                                return theChoice.id == theSelection.id;
                            })}
                            selectionText={getSpecialItemDetails(theSpecialItem, this.props.special)}
                        >
                            {(index+1)+". "+theSpecialItem.display_name}
                        </MenuItemChoiceSelection>
                    );
                })}
            </div>
        );
    }

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'choices':
                return this.renderItemChoices();

            case 'food_item':
                return this.renderFoodItem();

            case 'pizza':
                return this.renderPizza();

            case 'pizza_toppings':
                return this.renderPizzaToppings();
    
            case 'pizza_crusts':
                return this.renderPizzaCrusts();

            case 'pizza_sauces':
                return this.renderPizzaSauces();

            case 'custom_pizza':
                return this.renderCustomPizza();

            case 'custom_pizza_toppings':
                return this.renderCustomPizzaToppings();
    
            case 'custom_pizza_crusts':
                return this.renderCustomPizzaCrusts();

            case 'custom_pizza_sauces':
                return this.renderCustomPizzaSauces();
            
            case 'completed':
                return this.renderCompleted();
            
            default:
                return this.renderInfo();
        }
    }

    renderFoodItem() {
        return (
            <ViewFoodItem 
                specialFoodItem={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderPizza() {
        return (
            <ViewPizza 
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderPizzaToppings() {
        return (
            <ViewPizzaToppings
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderPizzaCrusts() {
        return (
            <ViewPizzaCrusts
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderPizzaSauces() {
        return (
            <ViewPizzaSauces
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderCustomPizza() {
        return (
            <ViewCustomPizza 
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderCustomPizzaToppings() {
        return (
            <ViewCustomPizzaToppings
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderCustomPizzaCrusts() {
        return (
            <ViewCustomPizzaCrusts
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderCustomPizzaSauces() {
        return (
            <ViewCustomPizzaSauces
                specialPizza={this.state.specialItem}
                index={this.state.curIndex}
            />
        );
    }

    renderItemChoices() {
        return (
            <ViewItemChoices 
                index={this.state.curIndex}
                updateSpecialItem={(item) => this.setState(() => ({
                    specialItem: item
                }))}
            />
        );
    }

    renderCompleted() {
        return (
            <MenuItemAdded 
                item={this.props.special} 
                handleClose={this.handleClose}
                handleCart={this.handleCart}
            />
        );
    }

    renderInfo() {
        return (
            <div className="modals-bottom-margin">
                <div className="menu-item-window">
                    <MenuItemInformation item={this.props.special} />

                    {this.renderSpecialItems()}
                </div>
                <div className="fixed-wrapper-for-add-to-order">
                    <MenuItemSubmitButton
                        itemtype="special"
                        price={generateSpecialPrice(this.props.special, this.props.cartItem)}
                        showCompleted={this.showCompleted}
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                isOpen={this.props.open}
                contentLabel="View Special"
                overlayClassName="modal-overlay"
                className="modal-window"
            >
                <div>
                    <ModalCloseButton 
                        clickAction={() => { this.props.dispatch(closeSpecial()) }} 
                    />

                    {this.renderActivePanel()}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        curPanel: state.panels.special,
        special: state.currentMenuItem.item,
        cartItem: state.cartItem,
        open: state.modals.special
    };
};

export default connect(mapStateToProps)(ViewSpecialModal);
